export default __webpack_public_path__ + "static/media/47.5cac4c1b.svg";